module.exports = { "default": require("core-js/library/fn/object/create"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/.deno/babel-runtime@6.26.0/~/babel-runtime/core-js/object/create.js
// module id = 179
// module chunks = 0